import {
  ApiResponse,
  isDashboardReportType,
  StaffDashboardRole,
  StaffDashboardStats,
} from '@/types';
import api from './client';

const dashboardEndpoints: Record<StaffDashboardRole, string> = {
  manager: '/dashboard/manager',
  coach: '/dashboard/coach',
  medical: '/dashboard/medical',
  scout: '/dashboard/scout',
};

const validateDashboardReportTypes = (stats: StaffDashboardStats): void => {
  const reports = 'recentReportFeed' in stats
    ? stats.recentReportFeed
    : Array.isArray(stats.recentReports)
      ? stats.recentReports
      : [];

  for (const report of reports) {
    if (!isDashboardReportType(report.type)) {
      throw new Error(`Invalid dashboard report type: ${String(report.type)}`);
    }
  }
};

// Dashboard API
export const dashboardAPI = {
  getForRole: async (role: StaffDashboardRole): Promise<ApiResponse<StaffDashboardStats>> => {
    if (!Object.prototype.hasOwnProperty.call(dashboardEndpoints, role)) {
      throw new Error(`Unsupported dashboard role: ${role}`);
    }

    const endpoint = dashboardEndpoints[role];
    const response = await api.get(endpoint);
    const payload: ApiResponse<StaffDashboardStats> = response.data;
    validateDashboardReportTypes(payload.data);
    return payload;
  },

  getAnalytics: async (): Promise<ApiResponse<unknown>> => {
    const response = await api.get('/dashboard/analytics');
    return response.data;
  },
};
